<script setup>
import BlankUser from '@/assets/images/blank-user.png'
import { useAuthStore } from '@/pinia/auth'
import { config } from '@/utils/config'
import { localisedDate } from '@/utils/date'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'

const authStore = useAuthStore()
const router = useRouter()
const logo_src = computed(() => {
  return authStore.image ? config.image_base_url + authStore.image : undefined
})
const isDropdown = ref(false)
const fullName = computed(() => {
  return `${authStore.firstName} ${authStore.lastName}`
})
const logout = () => {
  router.replace({ path: '/logout', query: { path: authStore.superuser ? '/login-admin' : '/login' } })
}
</script>

<template>
  <div
    class="w-full items-center relative border-b"
    :style="{ height: '65px' }"
    :class="authStore.isPortal ? 'bg-blue-900 text-white' : 'bg-white text-black'"
  >
    <div class="px-3 md:px-10">
      <slot>
        <h2>{{ localisedDate(new Date(), { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' }) }}</h2>
      </slot>
    </div>
    <div class="ml-auto p-4 hidden sm:flex gap-4 items-center px-3 md:px-10">
      <router-link to="/">
        <div class="bg-white rounded-full h-8 w-8 text-center">
          <i class="fal fa-home text-black" :style="{ 'line-height': '2rem' }" />
        </div>
      </router-link>
      <div class="border-solid border-l h-8" :class="authStore.isPortal ? 'border-gray-700' : 'border-gray-400'" />
      <div class="flex items-center cursor-pointer" @click.stop="isDropdown = !isDropdown">
        <div class="relative bg-white rounded-full h-8 w-8 text-center mr-3 overflow-hidden">
          <img
            id="user_profile"
            :src="logo_src"
            class="m-auto top-1/2 absolute transform -translate-y-1/2"
            @error="(event) => (event.target.src = BlankUser)"
          />
        </div>
        <i v-if="isDropdown" class="fal fa-chevron-up" :style="{ 'line-height': '2rem' }" />
        <i v-else class="fal fa-chevron-down" :style="{ 'line-height': '2rem' }" />
      </div>
    </div>
    <div
      v-if="isDropdown"
      v-click-outside="() => (isDropdown = false)"
      class="bg-white text-black absolute right-0 shadow-lg z-50 p-6 rounded-bl-lg border-t hidden sm:block"
      :style="{ top: '100%' }"
    >
      <div class="ml-8">
        <span class="font-light">{{ fullName }}</span>
      </div>
      <div class="ml-8 mb-4">
        <span class="font-light">{{ authStore.email }}</span>
      </div>
      <div class="border-solid border-t border-gray-500 mb-4" />
      <button class="cursor-pointer" @click="logout">
        <div class="flex items-center">
          <i class="fal fa-sign-out w-8" />
          <span>Logout</span>
        </div>
      </button>
    </div>
  </div>
</template>
